import {ConversationEventType} from '@stripe-internal/conversations-client';

/**
 * Emits enabled input modes from a server conversation context when present.
 * Shared by send-message, submit-message-part, and action response paths.
 */
export function emitInputModeContextValues(
  emitConversationEvent: (event: ConversationEventType) => void,
  conversationId: string,
  enabledInputModes: unknown,
): void {
  if (
    !Array.isArray(enabledInputModes) ||
    !enabledInputModes.every((mode) => typeof mode === 'string')
  ) {
    return;
  }

  emitConversationEvent({
    name: 'conversation-set-context-values',
    conversationId,
    values: {enabledInputModes},
  });
}
